/* Deckaura Random Tarot Card — Enterprise V5 */
(function () {
  "use strict";

  var FALLBACK_PRICES = {
    essential: "$5.99",
    deeper: "$9.99",
    indepth: "$16.99",
  };
  var PACKAGE_NAMES = {
    essential: "Decode This Card",
    deeper: "Clarify the Message",
    indepth: "Map the Path Ahead",
  };
  var PACKAGE_SCOPE = {
    essential: {
      added: 0,
      horizon: "direct",
      promise:
        "Direct application of the original card with one grounded next step",
    },
    deeper: {
      added: 0,
      horizon: "practical_steps",
      promise:
        "Deeper interpretation of the original card, possible patterns and practical next steps",
    },
    indepth: {
      added: 0,
      horizon: "30_days",
      promise:
        "In-depth interpretation of the original card, options, safeguards and a 30-day action and reflection plan",
    },
  };
  var STORAGE_KEY_PREFIX = "deckaura.random_tarot.v5";
  var STORAGE_TTL = 24 * 60 * 60 * 1000;
  var MIN_QUESTION = 8;
  var FOCI = [
    {
      id: "love",
      label: "Love & Relationships",
      suggestions: [
        "What should I understand about this connection?",
        "What pattern is affecting this relationship?",
        "What is within my control next?",
      ],
    },
    {
      id: "career",
      label: "Career & Money",
      suggestions: [
        "What should I understand about my next career move?",
        "What may be blocking my progress?",
        "What strength should I use right now?",
      ],
    },
    {
      id: "decision",
      label: "A Decision",
      suggestions: [
        "What am I not seeing about this choice?",
        "What should I consider before deciding?",
        "What is the healthiest available direction?",
      ],
    },
    {
      id: "timing",
      label: "Timing",
      suggestions: [
        "What may be creating movement or delay?",
        "What condition needs to change first?",
        "What can I do while I wait?",
      ],
    },
    {
      id: "self",
      label: "Self-Discovery",
      suggestions: [
        "What pattern in me is asking for attention?",
        "What am I avoiding or overidentifying with?",
        "What would integration look like this month?",
      ],
    },
    {
      id: "sign",
      label: "A Sign",
      suggestions: [
        "What do I most need to see right now?",
        "What is this restlessness pointing to?",
        "What should I pay attention to this week?",
      ],
    },
  ];
  var CLARIFIERS = [
    "Is this a green light or a warning?",
    "What am I not seeing?",
    "What should I do next?",
    "What could change the direction?",
    "Why does this pattern keep repeating?",
  ];

  var LANGUAGE = {
    en: {
      suggestions: null,
      lines: [
        "What the card highlights for your chosen focus",
        "The hidden condition affecting the situation",
        "The safest next step within your control",
      ],
      firstLineNoFocus: "What the card highlights for your question",
      uprightLine: "Upright, this energy is visible and active.",
      reversedLine:
        "Reversed, this energy may be blocked, internalized, delayed or under review.",
      openQuestion: function (card) {
        return "Is " + card + " a green light or a warning for this question?";
      },
      courtQuestion: function (card) {
        return "Does " + card + " describe you, another person’s role, or an energy you need to embody?";
      },
      resultCta: function (card) {
        return "See what " + card + " means for your question ↓";
      },
      clarifierHook: function (value, card) {
        return (
          "Your personal reading will answer “" +
          value +
          "” by keeping " +
          card +
          " as the anchor."
        );
      },
      continueEssential: function (card) {
        return "Decode " + card;
      },
      continueDeeper: function (card) {
        return "Explore " + card + " in depth";
      },
      continueIndepth: function (card) {
        return "Map My Path from " + card;
      },
      shareTitle: "My Deckaura one-card tarot result",
      shareQuestion: "Question",
      restored: "Saved reading restored. Available for up to 24 hours after your draw.",
      priceReady: "Secure local prices confirmed · one-time purchase.",
      priceLoading: "Confirming secure local prices…",
      priceFallback:
        "Exact local price will be confirmed before secure checkout.",
      priceQueued:
        "Confirming the secure local price… Checkout will open automatically.",
      checkoutPreparing: "Preparing your secure Shopify checkout…",
      cartReady: "Package secured. Opening Shopify checkout…",
      checkoutFailed:
        "Checkout could not open. Your card and package are kept; please try again.",
      checkoutLong:
        "Checkout is taking longer than expected. Your selection is saved; try again if no checkout opens.",
      loadFailed:
        "Secure reading options could not load. Refresh the page to try again.",
      retrying: "Retrying secure checkout…",
      contextIncluded: "Your context is included",
      saved: "Saved for 24 hours",
    },
    tr: {
      suggestions: [
        [
          "Bu bağlantı hakkında neyi anlamalıyım?",
          "Bu ilişkiyi hangi örüntü etkiliyor?",
          "Bundan sonra kontrolümde olan nedir?",
        ],
        [
          "Bir sonraki kariyer adımım hakkında neyi anlamalıyım?",
          "İlerlememi ne engelliyor olabilir?",
          "Şu anda hangi gücümü kullanmalıyım?",
        ],
        [
          "Bu seçimde neyi göremiyorum?",
          "Karar vermeden önce neyi değerlendirmeliyim?",
          "En sağlıklı yön hangisi?",
        ],
        [
          "Hareketi veya gecikmeyi ne yaratıyor olabilir?",
          "Önce hangi koşul değişmeli?",
          "Beklerken ne yapabilirim?",
        ],
        [
          "İçimde hangi örüntü ilgi istiyor?",
          "Neyden kaçınıyor veya neyle kendimi fazla özdeşleştiriyorum?",
          "Bu ay bütünleşme nasıl görünürdü?",
        ],
        [
          "Şu anda en çok neyi görmem gerekiyor?",
          "Bu huzursuzluk neye işaret ediyor?",
          "Bu hafta neye dikkat etmeliyim?",
        ],
      ],
      lines: [
        "Kartın seçtiğiniz odak için vurguladığı nokta",
        "Durumu etkileyen görünmeyen koşul",
        "Kontrolünüzdeki en güvenli sonraki adım",
      ],
      firstLineNoFocus: "Kartın sorunuz için vurguladığı nokta",
      uprightLine: "Düz konumda bu enerji görünür ve etkindir.",
      reversedLine:
        "Ters konumda bu enerji engellenmiş, içe dönmüş, gecikmiş veya yeniden değerlendiriliyor olabilir.",
      openQuestion: function (card) {
        return card + " bu soru için yeşil ışık mı, yoksa bir uyarı mı?";
      },
      courtQuestion: function (card) {
        return card + " sizi mi, başka birinin rolünü mü, yoksa somutlaştırmanız gereken bir enerjiyi mi anlatıyor?";
      },
      resultCta: function (card) {
        return card + " kartının sorunuz için anlamını görün ↓";
      },
      clarifierHook: function (value, card) {
        return (
          "Kişisel yorumunuz “" +
          value +
          "” sorusunu " +
          card +
          " kartını merkezde tutarak yanıtlayacak."
        );
      },
      continueEssential: function (card) {
        return card + " kartını çözümle";
      },
      continueDeeper: function (card) {
        return card + " kartını derinlemesine incele";
      },
      continueIndepth: function (card) {
        return card + " ile yolumu haritala";
      },
      shareTitle: "Deckaura tek kart tarot sonucum",
      shareQuestion: "Soru",
      restored:
        "Kaydedilen yorum geri getirildi. Kart çekiminden itibaren en fazla 24 saat kullanılabilir.",
      priceReady: "Güvenli yerel fiyat doğrulandı · tek seferlik ödeme.",
      priceLoading: "Güvenli yerel fiyat doğrulanıyor…",
      priceFallback: "Kesin yerel fiyat güvenli ödeme öncesinde doğrulanacak.",
      priceQueued:
        "Güvenli yerel fiyat doğrulanıyor… Hazır olduğunda ödeme otomatik açılacak.",
      checkoutPreparing: "Güvenli Shopify ödemeniz hazırlanıyor…",
      cartReady: "Paket hazır. Shopify ödeme sayfası açılıyor…",
      checkoutFailed:
        "Ödeme açılamadı. Kartınız ve paketiniz korundu; lütfen yeniden deneyin.",
      checkoutLong:
        "Ödeme beklenenden uzun sürüyor. Seçiminiz kaydedildi; açılmazsa yeniden deneyin.",
      loadFailed:
        "Güvenli yorum seçenekleri yüklenemedi. Yeniden denemek için sayfayı yenileyin.",
      retrying: "Güvenli ödeme yeniden deneniyor…",
      contextIncluded: "Bağlamınız eklendi",
      saved: "24 saat kaydedildi",
    },
    es: {
      suggestions: [
        [
          "¿Qué debería comprender sobre esta conexión?",
          "¿Qué patrón está afectando a esta relación?",
          "¿Qué está bajo mi control ahora?",
        ],
        [
          "¿Qué debería comprender sobre mi próximo paso profesional?",
          "¿Qué puede estar bloqueando mi progreso?",
          "¿Qué fortaleza debería usar ahora?",
        ],
        [
          "¿Qué no estoy viendo en esta elección?",
          "¿Qué debería considerar antes de decidir?",
          "¿Cuál es la dirección más saludable disponible?",
        ],
        [
          "¿Qué puede estar creando movimiento o demora?",
          "¿Qué condición debe cambiar primero?",
          "¿Qué puedo hacer mientras espero?",
        ],
        [
          "¿Qué patrón en mí pide atención?",
          "¿Qué estoy evitando o con qué me identifico demasiado?",
          "¿Cómo sería integrar esto durante este mes?",
        ],
        [
          "¿Qué necesito ver ahora mismo?",
          "¿Hacia qué apunta esta inquietud?",
          "¿A qué debería prestar atención esta semana?",
        ],
      ],
      lines: [
        "Lo que la carta destaca para tu enfoque",
        "La condición oculta que afecta a la situación",
        "El siguiente paso más seguro bajo tu control",
      ],
      firstLineNoFocus: "Lo que la carta destaca para tu pregunta",
      uprightLine: "Al derecho, esta energía es visible y activa.",
      reversedLine:
        "Invertida, esta energía puede estar bloqueada, interiorizada, retrasada o en revisión.",
      openQuestion: function (card) {
        return "¿" + card + " es luz verde o una advertencia para esta pregunta?";
      },
      courtQuestion: function (card) {
        return "¿" + card + " te describe a ti, el papel de otra persona o una energía que necesitas encarnar?";
      },
      resultCta: function (card) {
        return "Mira qué significa " + card + " para tu pregunta ↓";
      },
      clarifierHook: function (value, card) {
        return (
          "Tu lectura personal responderá “" +
          value +
          "” manteniendo " +
          card +
          " como ancla."
        );
      },
      continueEssential: function (card) {
        return "Interpretar " + card;
      },
      continueDeeper: function (card) {
        return "Explorar " + card + " en profundidad";
      },
      continueIndepth: function (card) {
        return "Trazar mi camino desde " + card;
      },
      shareTitle: "Mi resultado de tarot de una carta de Deckaura",
      shareQuestion: "Pregunta",
      restored:
        "Lectura guardada restaurada. Disponible hasta 24 horas después de sacar la carta.",
      priceReady: "Precio local seguro confirmado · pago único.",
      priceLoading: "Confirmando precios locales seguros…",
      priceFallback:
        "El precio local exacto se confirmará antes del pago seguro.",
      priceQueued:
        "Confirmando el precio local seguro… El pago se abrirá automáticamente.",
      checkoutPreparing: "Preparando tu pago seguro de Shopify…",
      cartReady: "Paquete preparado. Abriendo el pago de Shopify…",
      checkoutFailed:
        "No se pudo abrir el pago. Tu carta y paquete se han conservado; inténtalo de nuevo.",
      checkoutLong:
        "El pago tarda más de lo esperado. Tu selección está guardada; inténtalo de nuevo si no se abre.",
      loadFailed:
        "No se pudieron cargar las opciones de lectura. Actualiza la página para intentarlo de nuevo.",
      retrying: "Reintentando el pago seguro…",
      contextIncluded: "Tu contexto está incluido",
      saved: "Guardado durante 24 horas",
    },
    de: {
      suggestions: [
        [
          "Was sollte ich über diese Verbindung verstehen?",
          "Welches Muster beeinflusst diese Beziehung?",
          "Was liegt als Nächstes in meiner Hand?",
        ],
        [
          "Was sollte ich über meinen nächsten Karriereschritt verstehen?",
          "Was könnte meinen Fortschritt blockieren?",
          "Welche Stärke sollte ich jetzt einsetzen?",
        ],
        [
          "Was übersehe ich bei dieser Wahl?",
          "Was sollte ich vor der Entscheidung bedenken?",
          "Welche Richtung ist derzeit am gesündesten?",
        ],
        [
          "Was könnte Bewegung oder Verzögerung verursachen?",
          "Welche Bedingung muss sich zuerst ändern?",
          "Was kann ich tun, während ich warte?",
        ],
        [
          "Welches Muster in mir braucht Aufmerksamkeit?",
          "Was vermeide ich oder womit identifiziere ich mich zu stark?",
          "Wie könnte Integration in diesem Monat aussehen?",
        ],
        [
          "Was muss ich jetzt am dringendsten sehen?",
          "Worauf weist diese Unruhe hin?",
          "Worauf sollte ich diese Woche achten?",
        ],
      ],
      lines: [
        "Was die Karte für deinen Fokus hervorhebt",
        "Die verborgene Bedingung der Situation",
        "Der sicherste nächste Schritt in deiner Hand",
      ],
      firstLineNoFocus: "Was die Karte für deine Frage hervorhebt",
      uprightLine: "Aufrecht ist diese Energie sichtbar und aktiv.",
      reversedLine:
        "Umgekehrt kann diese Energie blockiert, verinnerlicht, verzögert oder in Prüfung sein.",
      openQuestion: function (card) {
        return "Ist " + card + " für diese Frage grünes Licht oder eine Warnung?";
      },
      courtQuestion: function (card) {
        return "Beschreibt " + card + " dich, die Rolle einer anderen Person oder eine Energie, die du verkörpern solltest?";
      },
      resultCta: function (card) {
        return "Sieh, was " + card + " für deine Frage bedeutet ↓";
      },
      clarifierHook: function (value, card) {
        return (
          "Deine persönliche Legung beantwortet „" +
          value +
          "“, wobei " +
          card +
          " der Anker bleibt."
        );
      },
      continueEssential: function (card) {
        return card + " deuten";
      },
      continueDeeper: function (card) {
        return card + " vertieft erkunden";
      },
      continueIndepth: function (card) {
        return "Meinen Weg ab " + card + " skizzieren";
      },
      shareTitle: "Mein Ein-Karten-Tarotergebnis von Deckaura",
      shareQuestion: "Frage",
      restored:
        "Gespeicherte Legung wiederhergestellt. Bis zu 24 Stunden nach dem Ziehen verfügbar.",
      priceReady: "Sicherer lokaler Preis bestätigt · einmaliger Kauf.",
      priceLoading: "Sichere lokale Preise werden bestätigt…",
      priceFallback:
        "Der genaue lokale Preis wird vor dem sicheren Checkout bestätigt.",
      priceQueued:
        "Der sichere lokale Preis wird bestätigt… Der Checkout öffnet sich automatisch.",
      checkoutPreparing: "Dein sicherer Shopify-Checkout wird vorbereitet…",
      cartReady: "Paket gesichert. Shopify-Checkout wird geöffnet…",
      checkoutFailed:
        "Der Checkout konnte nicht geöffnet werden. Karte und Paket bleiben erhalten; bitte versuche es erneut.",
      checkoutLong:
        "Der Checkout dauert länger als erwartet. Deine Auswahl ist gespeichert; versuche es erneut, falls er sich nicht öffnet.",
      loadFailed:
        "Die sicheren Legungsoptionen konnten nicht geladen werden. Aktualisiere die Seite und versuche es erneut.",
      retrying: "Sicherer Checkout wird erneut versucht…",
      contextIncluded: "Dein Kontext ist enthalten",
      saved: "24 Stunden gespeichert",
    },
    "pt-br": {
      suggestions: [
        [
          "O que devo entender sobre esta conexão?",
          "Que padrão está afetando este relacionamento?",
          "O que está sob meu controle agora?",
        ],
        [
          "O que devo entender sobre meu próximo passo profissional?",
          "O que pode estar bloqueando meu progresso?",
          "Que força devo usar agora?",
        ],
        [
          "O que não estou vendo nesta escolha?",
          "O que devo considerar antes de decidir?",
          "Qual é a direção mais saudável disponível?",
        ],
        [
          "O que pode estar criando movimento ou atraso?",
          "Que condição precisa mudar primeiro?",
          "O que posso fazer enquanto espero?",
        ],
        [
          "Que padrão em mim pede atenção?",
          "O que estou evitando ou com o que me identifico demais?",
          "Como seria integrar isso neste mês?",
        ],
        [
          "O que mais preciso ver agora?",
          "Para onde esta inquietação aponta?",
          "A que devo prestar atenção esta semana?",
        ],
      ],
      lines: [
        "O que a carta destaca para o foco escolhido",
        "A condição oculta que afeta a situação",
        "O próximo passo mais seguro sob seu controle",
      ],
      firstLineNoFocus: "O que a carta destaca para sua pergunta",
      uprightLine: "Em pé, esta energia está visível e ativa.",
      reversedLine:
        "Invertida, esta energia pode estar bloqueada, interiorizada, atrasada ou em revisão.",
      openQuestion: function (card) {
        return card + " é sinal verde ou um alerta para esta pergunta?";
      },
      courtQuestion: function (card) {
        return card + " descreve você, o papel de outra pessoa ou uma energia que você precisa incorporar?";
      },
      resultCta: function (card) {
        return "Veja o que " + card + " significa para sua pergunta ↓";
      },
      clarifierHook: function (value, card) {
        return (
          "Sua leitura pessoal responderá “" +
          value +
          "” mantendo " +
          card +
          " como âncora."
        );
      },
      continueEssential: function (card) {
        return "Interpretar " + card;
      },
      continueDeeper: function (card) {
        return "Explorar " + card + " em profundidade";
      },
      continueIndepth: function (card) {
        return "Mapear meu caminho a partir de " + card;
      },
      shareTitle: "Meu resultado de tarô de uma carta da Deckaura",
      shareQuestion: "Pergunta",
      restored: "Leitura salva restaurada. Disponível por até 24 horas após tirar a carta.",
      priceReady: "Preço local seguro confirmado · pagamento único.",
      priceLoading: "Confirmando preços locais seguros…",
      priceFallback:
        "O preço local exato será confirmado antes do checkout seguro.",
      priceQueued:
        "Confirmando o preço local seguro… O checkout abrirá automaticamente.",
      checkoutPreparing: "Preparando seu checkout seguro da Shopify…",
      cartReady: "Pacote preparado. Abrindo o checkout da Shopify…",
      checkoutFailed:
        "Não foi possível abrir o checkout. Sua carta e pacote foram preservados; tente novamente.",
      checkoutLong:
        "O checkout está demorando mais que o esperado. Sua escolha foi salva; tente novamente se ele não abrir.",
      loadFailed:
        "Não foi possível carregar as opções de leitura. Atualize a página para tentar novamente.",
      retrying: "Tentando o checkout seguro novamente…",
      contextIncluded: "Seu contexto foi incluído",
      saved: "Salvo por 24 horas",
    },
    "pt-pt": {
      suggestions: [
        [
          "O que devo compreender sobre esta ligação?",
          "Que padrão está a afetar esta relação?",
          "O que está agora sob o meu controlo?",
        ],
        [
          "O que devo compreender sobre o meu próximo passo profissional?",
          "O que poderá estar a bloquear o meu progresso?",
          "Que força devo usar agora?",
        ],
        [
          "O que não estou a ver nesta escolha?",
          "O que devo considerar antes de decidir?",
          "Qual é a direção mais saudável disponível?",
        ],
        [
          "O que poderá estar a criar movimento ou atraso?",
          "Que condição precisa de mudar primeiro?",
          "O que posso fazer enquanto espero?",
        ],
        [
          "Que padrão em mim pede atenção?",
          "O que estou a evitar ou com que me identifico em excesso?",
          "Como seria integrar isto durante este mês?",
        ],
        [
          "O que mais preciso de ver agora?",
          "Para onde aponta esta inquietação?",
          "A que devo prestar atenção esta semana?",
        ],
      ],
      lines: [
        "O que a carta destaca para o foco escolhido",
        "A condição oculta que afeta a situação",
        "O passo seguinte mais seguro sob o seu controlo",
      ],
      firstLineNoFocus: "O que a carta destaca para a sua pergunta",
      uprightLine: "Direita, esta energia está visível e ativa.",
      reversedLine:
        "Invertida, esta energia poderá estar bloqueada, interiorizada, atrasada ou em revisão.",
      openQuestion: function (card) {
        return card + " é luz verde ou um aviso para esta pergunta?";
      },
      courtQuestion: function (card) {
        return card + " descreve-o a si, o papel de outra pessoa ou uma energia que precisa de incorporar?";
      },
      resultCta: function (card) {
        return "Veja o que " + card + " significa para a sua pergunta ↓";
      },
      clarifierHook: function (value, card) {
        return (
          "A sua leitura pessoal responderá a “" +
          value +
          "”, mantendo " +
          card +
          " como âncora."
        );
      },
      continueEssential: function (card) {
        return "Interpretar " + card;
      },
      continueDeeper: function (card) {
        return "Explorar " + card + " em profundidade";
      },
      continueIndepth: function (card) {
        return "Mapear o meu caminho a partir de " + card;
      },
      shareTitle: "O meu resultado de tarot de uma carta da Deckaura",
      shareQuestion: "Pergunta",
      restored:
        "Leitura guardada restaurada. Disponível até 24 horas após tirar a carta.",
      priceReady: "Preço local seguro confirmado · pagamento único.",
      priceLoading: "A confirmar preços locais seguros…",
      priceFallback:
        "O preço local exato será confirmado antes do pagamento seguro.",
      priceQueued:
        "A confirmar o preço local seguro… O pagamento abrirá automaticamente.",
      checkoutPreparing: "A preparar o seu pagamento seguro da Shopify…",
      cartReady: "Pacote preparado. A abrir o pagamento da Shopify…",
      checkoutFailed:
        "Não foi possível abrir o pagamento. A sua carta e pacote foram preservados; tente novamente.",
      checkoutLong:
        "O pagamento está a demorar mais do que o esperado. A sua escolha foi guardada; tente novamente se não abrir.",
      loadFailed:
        "Não foi possível carregar as opções de leitura. Atualize a página para tentar novamente.",
      retrying: "A tentar novamente o pagamento seguro…",
      contextIncluded: "O seu contexto foi incluído",
      saved: "Guardado durante 24 horas",
    },
  };

  function query(scope, selector) {
    return scope ? scope.querySelector(selector) : null;
  }
  function queryAll(scope, selector) {
    return scope
      ? Array.prototype.slice.call(scope.querySelectorAll(selector))
      : [];
  }
  function clean(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }
  function titleCase(value) {
    value = clean(value);
    return value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
  }
  function hash(value) {
    var h = 2166136261;
    for (var i = 0; i < value.length; i += 1) {
      h ^= value.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    return (h >>> 0).toString(36);
  }
  function randomIndex(max) {
    if (window.crypto && window.crypto.getRandomValues) {
      var data = new Uint32Array(1);
      window.crypto.getRandomValues(data);
      return data[0] % max;
    }
    return Math.floor(Math.random() * max);
  }
  function localeId() {
    return (window.DA_RT52_I18N && window.DA_RT52_I18N.locale) || "en";
  }

  function storageKey() {
    return STORAGE_KEY_PREFIX + "." + localeId();
  }
  function language() {
    return LANGUAGE[localeId()] || LANGUAGE.en;
  }
  function translate(value) {
    var text = String(value == null ? "" : value);
    if (localeId() === "en" || !text) return text;
    var curated = (window.DA_RT52_I18N && window.DA_RT52_I18N.copy) || {};
    var generated = window.DeckauraToolTranslations || {};
    return curated[text] || generated[text] || text;
  }
  function track(name, props) {
    try {
      var audit = new URLSearchParams(window.location.search || "");
      if (audit.has("codex_audit") || audit.has("deckaura_internal") || audit.has("alltools_audit") || audit.has("funnel_audit") || audit.get("internal") === "true" || audit.get("traffic_type") === "internal") return;
      if (window.clarity) {
        window.clarity("event", name);
        Object.keys(props || {}).forEach(function (key) {
          window.clarity("set", "rt52_" + key, String(props[key]));
        });
      }
    } catch (_) {}
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, random_tarot: props || {} });
    } catch (_) {}
  }
  function localizeStatic(root) {
    if (localeId() === "en") return;
    var walker = document.createTreeWalker(root, window.NodeFilter.SHOW_TEXT);
    var nodes = [],
      node;
    while ((node = walker.nextNode())) nodes.push(node);
    nodes.forEach(function (textNode) {
      var raw = textNode.nodeValue || "",
        value = raw.trim();
      if (!value) return;
      var localized = translate(value);
      if (localized !== value)
        textNode.nodeValue = raw.replace(value, localized);
      else if (value.indexOf(" · Verified purchase") > -1)
        textNode.nodeValue = raw.replace(
          "Verified purchase",
          translate("Verified purchase"),
        );
    });
    queryAll(root, "[placeholder],[aria-label],[alt],[title]").forEach(
      function (element) {
        ["placeholder", "aria-label", "alt", "title"].forEach(function (name) {
          if (!element.hasAttribute(name)) return;
          var value = element.getAttribute(name),
            localized = translate(value);
          if (localized !== value) element.setAttribute(name, localized);
        });
      },
    );
  }

  function boot(root) {
    if (root.getAttribute("data-rt52-ready") === "true") return;
    var deck = window.DA_RT52_CARDS || [];
    if (deck.length !== 78) return;
    root.setAttribute("data-rt52-ready", "true");
    localizeStatic(root);

    var pack = language();
    var state = {
      focus: "",
      question: "",
      card: null,
      cardIndex: -1,
      reversed: false,
      clarifier: "",
      context: "",
      tier: "deeper",
      readingReady: false,
      checkoutBusy: false,
      checkoutPending: false,
      checkoutFailed: false,
      lastEnabledSignature: "",
      expiresAt: 0,
    };
    var ask = query(root, "[data-rt52-ask]"),
      result = query(root, "[data-rt52-result]"),
      bridge = query(root, "[data-rt52-bridge]"),
      plans = query(root, "[data-rt52-plans]"),
      dock = query(root, "[data-rt52-dock]"),
      after = query(root, "[data-rt52-after]");
    var question = query(root, "[data-rt52-question]"),
      context = query(root, "[data-rt52-context]"),
      focuses = query(root, "[data-rt52-focuses]"),
      suggestions = query(root, "[data-rt52-suggestions]");
    var drawButton = query(root, "[data-rt52-draw]"),
      error = query(root, "[data-rt52-error]"),
      priceStatus = query(root, "[data-rt52-price-status]"),
      checkoutButton = query(root, "[data-rt52-checkout]"),
      retryButton = query(root, "[data-rt52-retry]");
    var cardElement = query(root, "[data-rt52-card]"),
      cardImage = query(root, "[data-rt52-card-image]"),
      mobileCard = query(root, "[data-rt52-mobile-card]"),
      mobileImage = query(root, "[data-rt52-mobile-image]");
    var restoreNote = query(root, "[data-rt52-restore]"),
      toast = query(root, "[data-rt52-toast]"),
      cartReview = query(root, "[data-rt52-cart-review]");
    var placeholder = {
      src: cardImage ? cardImage.src : "",
      srcset: cardImage ? cardImage.srcset : "",
      mobileSrc: mobileImage ? mobileImage.src : "",
    };
    var toastTimer = 0,
      configTimer = 0,
      checkoutTimer = 0,
      readingTimer = 0,
      drawTimer = 0,
      expiryTimer = 0,
      contextGeneration = 0,
      configuredGeneration = -1,
      checkoutAttempt = 0,
      drawPending = false,
      reviewPending = false,
      reviewReason = "",
      beforeReviewStatuses = [],
      returnStatuses = null,
      lastPricingSnapshot = null;

    function focusObject() {
      return (
        FOCI.filter(function (item) {
          return item.id === state.focus;
        })[0] || FOCI[5]
      );
    }
    function focusLabel() {
      return translate(focusObject().label);
    }
    function rawOrientation() {
      return state.reversed ? "Reversed" : "Upright";
    }
    function orientationLabel() {
      return translate(rawOrientation());
    }
    function cardName() {
      return state.card ? translate(state.card[0]) : "";
    }
    function meaningText() {
      if (!state.card) return "";
      var meanings = window.SC7CardMeaningKeys && window.SC7CardMeaningKeys[state.card[0]];
      var source = meanings && meanings[state.reversed ? 1 : 0];
      return translate(source || (state.reversed ? state.card[4] : state.card[3]));
    }
    function keywordLabels() {
      return state.card
        ? clean(meaningText())
            .split(",")
            .map(clean)
            .filter(Boolean)
        : [];
    }
    function recommendedTier() {
      return "deeper";
    }
    function showToast(text) {
      if (!toast) return;
      toast.textContent = text;
      toast.classList.add("is-visible");
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(function () {
        toast.classList.remove("is-visible");
      }, 2600);
    }
    function hasCurrentReading() {
      return Boolean(state.card && Number.isFinite(state.expiresAt) && state.expiresAt > Date.now());
    }
    function syncControls() {
      var locked = state.checkoutBusy || drawPending;
      /* A clarifier or context edit only schedules a reconfigure; checkout() applies it at once, so it does not block the bar. */
      checkoutButton.disabled = locked || !hasCurrentReading() || (configuredGeneration !== contextGeneration && !configTimer) || reviewPending || Boolean(cartReview && !cartReview.hidden);
      queryAll(root, "[data-rt52-plan],[data-rt52-start-over],[data-rt52-focuses] button,[data-rt52-suggestions] button,[data-rt52-clarifiers] button,[data-rt52-retry]").forEach(function (node) { node.disabled = locked; });
      question.readOnly = locked;
      context.readOnly = locked;
      drawButton.disabled = locked;
      root.classList.toggle("is-cart-review", reviewPending || Boolean(cartReview && !cartReview.hidden));
    }
    function setCheckoutBusy(value) {
      state.checkoutBusy = value === true;
      if (state.checkoutBusy) checkoutButton.setAttribute("aria-busy", "true");
      else checkoutButton.removeAttribute("aria-busy");
      syncControls();
    }
    function showRetry(value) {
      if (retryButton) retryButton.hidden = value !== true;
    }
    function clearCartReview() {
      reviewPending = false;
      reviewReason = "";
      beforeReviewStatuses = [];
      returnStatuses = null;
      if (cartReview) {
        cartReview.__deckauraRecoveryGeneration = (cartReview.__deckauraRecoveryGeneration || 0) + 1;
        cartReview.textContent = "";
        cartReview.hidden = true;
      }
      root.classList.remove("is-cart-review");
    }
    function sharedStatuses() {
      return queryAll(document, ".rt52-ddr #ddrGateNote,.rt52-ddr #ddrNote").map(function (node) { return { node: node, text: node.textContent }; });
    }
    function recoverableCartReason(reason) {
      return /^(reading_cart_conflict|cart_changed|cart_operation_busy|cart_result_uncertain|cart_read_failed|cart_add_failed|checkout_guard_unavailable|checkout_navigation_busy)$/.test(String(reason || ""));
    }
    function dismissReturnHint() {
      try { if (window.DeckauraCheckout && typeof window.DeckauraCheckout.dismissRecovery === "function") window.DeckauraCheckout.dismissRecovery(); } catch (_) {}
    }
    function cancelReconfigure() {
      window.clearTimeout(configTimer);
      configTimer = 0;
    }
    function invalidateContext() {
      contextGeneration += 1;
      checkoutAttempt += 1;
      cancelReconfigure();
      window.clearTimeout(readingTimer);
      window.clearTimeout(checkoutTimer);
      clearCartReview();
      if (state.readingReady) {
        try { if (window.DeckauraDeepReading && window.DeckauraDeepReading.update) window.DeckauraDeepReading.update({ resultReady: false, checkoutRecoveryHost: cartReview }); } catch (_) {}
      }
      state.readingReady = false;
      state.lastEnabledSignature = "";
      state.checkoutPending = false;
      state.checkoutFailed = false;
      configuredGeneration = -1;
      setCheckoutBusy(false);
      showRetry(false);
    }
    function cartReviewReady(generation, host) {
      if (generation !== contextGeneration || configuredGeneration !== generation || !hasCurrentReading() || host !== cartReview || !host || !host.isConnected) return;
      if (reviewReason === "reading_cart_conflict") {
        returnStatuses = beforeReviewStatuses.filter(function (entry) { return entry.node.isConnected && entry.node.textContent && entry.node.textContent !== entry.text; }).map(function (entry) { return { node: entry.node, text: entry.node.textContent }; });
      }
      reviewPending = false;
      state.checkoutFailed = false;
      window.clearTimeout(checkoutTimer);
      setCheckoutBusy(false);
      setPrices(lastPricingSnapshot);
      dismissReturnHint();
      try { host.focus({ preventScroll: true }); host.scrollIntoView({ behavior: "smooth", block: "start" }); } catch (_) {}
    }
    function expireReading() {
      if (!state.card || state.expiresAt > Date.now()) return false;
      var savedQuestion = question.value, savedFocus = state.focus;
      state.checkoutBusy = false;
      startOver();
      state.focus = savedFocus;
      state.question = savedQuestion;
      question.value = savedQuestion;
      query(root, "[data-rt52-count]").textContent = savedQuestion.length + " / 220";
      renderFocuses();
      renderSuggestions();
      error.textContent = translate("Saved reading has expired. Draw a new card to continue.");
      question.focus();
      return true;
    }
    function armExpiry() {
      window.clearTimeout(expiryTimer);
      if (!state.card) return;
      expiryTimer = window.setTimeout(function () {
        expireReading();
      }, Math.max(1, state.expiresAt - Date.now()));
    }
    function saveState() {
      try {
        if (!state.expiresAt) state.expiresAt = Date.now() + STORAGE_TTL;
        if (state.expiresAt <= Date.now()) return;
        var saved = {
          version: 5,
          expiresAt: state.expiresAt,
          focus: state.focus,
          question: clean(question.value).slice(0, 220),
          cardIndex: state.cardIndex,
          reversed: state.reversed,
          clarifier: state.clarifier,
          context: clean(context.value).slice(0, 360),
          tier: state.tier,
        };
        window.localStorage.setItem(storageKey(), JSON.stringify(saved));
      } catch (_) {}
    }
    function clearState() {
      try {
        window.localStorage.removeItem(storageKey());
      } catch (_) {}
    }
    function readState() {
      try {
        var saved = JSON.parse(
          window.localStorage.getItem(storageKey()) || "null",
        );
        if (
          !saved ||
          saved.version !== 5 ||
          !Number.isFinite(saved.expiresAt) ||
          saved.expiresAt <= Date.now() ||
          saved.expiresAt > Date.now() + STORAGE_TTL
        ) {
          clearState();
          return null;
        }
        return saved;
      } catch (_) {
        clearState();
        return null;
      }
    }
    function renderFocuses() {
      focuses.textContent = "";
      FOCI.forEach(function (item) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "rt52__focus";
        button.textContent = translate(item.label);
        button.setAttribute("aria-pressed", String(state.focus === item.id));
        button.disabled = state.checkoutBusy || drawPending;
        button.addEventListener("click", function () {
          if (state.checkoutBusy || drawPending) return;
          invalidateContext();
          state.focus = item.id;
          error.textContent = "";
          renderFocuses();
          renderSuggestions();
          saveState();
          track("random_tarot_focus_selected_v5", { focus: item.id });
        });
        focuses.appendChild(button);
      });
    }
    function suggestionList() {
      var index = FOCI.indexOf(focusObject());
      return (
        (pack.suggestions && pack.suggestions[index]) ||
        focusObject().suggestions.map(translate)
      );
    }
    function renderSuggestions(force) {
      suggestions.textContent = "";
      /* Without a picked focus the list stays closed until a too-short question needs a one-tap example. */
      if (!state.focus && force !== true) {
        suggestions.hidden = true;
        return;
      }
      suggestions.hidden = false;
      suggestionList().forEach(function (text) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "rt52__suggestion";
        button.textContent = text;
        button.disabled = state.checkoutBusy || drawPending;
        button.addEventListener("click", function () {
          if (state.checkoutBusy || drawPending) return;
          invalidateContext();
          question.value = text;
          state.question = text;
          query(root, "[data-rt52-count]").textContent = text.length + " / 220";
          error.textContent = "";
          saveState();
          track("random_tarot_suggestion_used_v5", { focus: state.focus });
        });
        suggestions.appendChild(button);
      });
    }
    function resetCardFace() {
      cardElement.classList.remove("is-result");
      cardElement.setAttribute("aria-label", translate("Face-down tarot card"));
      if (cardImage) {
        cardImage.src = placeholder.src;
        cardImage.srcset = placeholder.srcset;
        cardImage.alt = translate("Face-down tarot card");
        cardImage.style.transform = "";
      }
      if (mobileImage) {
        mobileImage.src = placeholder.mobileSrc;
        mobileImage.removeAttribute("srcset");
        mobileImage.alt = translate("Face-down tarot card");
        mobileImage.style.transform = "";
      }
      if (mobileCard) mobileCard.hidden = true;
      query(root, "[data-rt52-card-meta]").hidden = true;
      query(root, "[data-rt52-card-name]").hidden = true;
      query(root, "[data-rt52-card-orient]").hidden = true;
      query(root, "[data-rt52-caption]").hidden = true;
      query(root, "[data-rt52-copy]").hidden = true;
    }
    function validate() {
      state.question = clean(question.value);
      /* The focus is optional: focusObject() falls back to the general "A Sign" focus. */
      if (Array.from(state.question).length < MIN_QUESTION) {
        question.setAttribute("aria-invalid", "true");
        error.textContent = translate(
          "Add a little more context so your card has one clear job.",
        );
        if (suggestions.hidden) renderSuggestions(true);
        question.focus();
        return false;
      }
      error.textContent = "";
      question.removeAttribute("aria-invalid");
      return true;
    }
    function draw() {
      if (drawButton.disabled || state.checkoutBusy || !validate()) return;
      invalidateContext();
      var generation = contextGeneration;
      drawPending = true;
      syncControls();
      drawButton.textContent = translate("Drawing your card…");
      drawTimer = window.setTimeout(function () {
        if (generation !== contextGeneration || !drawPending) return;
        drawPending = false;
        state.cardIndex = randomIndex(deck.length);
        state.card = deck[state.cardIndex];
        state.reversed = randomIndex(100) < 38;
        state.clarifier = "";
        state.context = "";
        state.tier = recommendedTier();
        state.readingReady = false;
        state.lastEnabledSignature = "";
        state.expiresAt = Date.now() + STORAGE_TTL;
        context.value = "";
        query(root, "[data-rt52-context-count]").textContent = "0";
        renderResult(false);
        armExpiry();
        syncControls();
        drawButton.textContent = translate("Draw My Card");
      }, 650);
      track("random_tarot_draw_started_v5", { focus: state.focus });
    }
    function renderCard() {
      var rawName = state.card[0],
        name = cardName(),
        orientation = orientationLabel();
      var url = window.DeckauraTarotArt
        ? window.DeckauraTarotArt.url(rawName, 480)
        : "";
      var srcset = window.DeckauraTarotArt
        ? window.DeckauraTarotArt.url(rawName, 160) +
          " 160w, " +
          window.DeckauraTarotArt.url(rawName, 480) +
          " 480w, " +
          window.DeckauraTarotArt.url(rawName, 720) +
          " 720w"
        : "";
      cardElement.classList.add("is-result");
      cardElement.setAttribute(
        "aria-label",
        name + ", " + orientation.toLowerCase(),
      );
      [cardImage, mobileImage].forEach(function (image) {
        if (!image) return;
        if (url) image.src = url;
        if (srcset) image.srcset = srcset;
        image.alt = name + ", " + orientation.toLowerCase();
        image.style.transform = state.reversed ? "rotate(180deg)" : "";
      });
      if (mobileCard) mobileCard.hidden = false;
      query(root, "[data-rt52-caption]").hidden = false;
      query(root, "[data-rt52-caption]").textContent =
        name + " — " + orientation;
      query(root, "[data-rt52-mobile-caption]").textContent =
        name + " — " + orientation;
      query(root, "[data-rt52-copy]").hidden = false;
    }
    function renderClarifiers() {
      var holder = query(root, "[data-rt52-clarifiers]");
      holder.textContent = "";
      CLARIFIERS.forEach(function (raw) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "rt52__clarifier";
        button.textContent = translate(raw);
        button.setAttribute("aria-pressed", String(state.clarifier === raw));
        button.disabled = state.checkoutBusy;
        button.addEventListener("click", function () {
          if (state.checkoutBusy || !hasCurrentReading()) return;
          invalidateContext();
          state.clarifier = state.clarifier === raw ? "" : raw;
          renderClarifiers();
          renderClarifierHook();
          saveState();
          scheduleReconfigure();
          track("random_tarot_clarifier_selected_v5", {
            selected: state.clarifier ? 1 : 0,
          });
        });
        holder.appendChild(button);
      });
    }
    function renderClarifierHook() {
      var element = query(root, "[data-rt52-clarifier-hook]");
      if (!state.clarifier) {
        element.hidden = true;
        element.textContent = "";
        return;
      }
      element.textContent = pack.clarifierHook(
        translate(state.clarifier),
        cardName(),
      );
      element.hidden = false;
    }
    function updateFocusBullets() {
      query(root, "[data-rt52-essential-first]").textContent = state.focus ? pack.lines[0] : pack.firstLineNoFocus;
      query(root, "[data-rt52-deeper-focus]").textContent = pack.lines[1];
      query(root, "[data-rt52-indepth-focus]").textContent = pack.lines[2];
    }
    function continueLabel(tier) {
      if (!state.card) return translate("Continue with my reading");
      if (tier === "essential") return pack.continueEssential(cardName());
      if (tier === "indepth") return pack.continueIndepth(cardName());
      return pack.continueDeeper(cardName());
    }
    function syncLegacyTier() {
      queryAll(document, ".rt52-ddr [data-tier]").forEach(function (node) {
        var active = node.getAttribute("data-tier") === state.tier;
        node.classList.toggle("is-recommended", active);
        node.setAttribute("aria-checked", String(active));
      });
    }
    function syncPlanSelection() {
      queryAll(root, "[data-rt52-plan]").forEach(function (node) {
        var active = node.getAttribute("data-rt52-plan") === state.tier;
        node.classList.toggle("is-recommended", active);
        node.setAttribute("aria-checked", String(active));
        node.tabIndex = active ? 0 : -1;
      });
      checkoutButton.firstChild.textContent = continueLabel(state.tier) + " — ";
    }
    function updatePlan(tier, silent) {
      if (!silent && state.checkoutBusy) return;
      if (!silent && state.tier !== tier) invalidateContext();
      state.tier = /^(essential|deeper|indepth)$/.test(tier) ? tier : "deeper";
      syncPlanSelection();
      setPrices(
        window.DeckauraDeepReading &&
          window.DeckauraDeepReading.getPricingSnapshot
          ? window.DeckauraDeepReading.getPricingSnapshot()
          : null,
      );
      if (state.readingReady) {
        try {
          if (window.DeckauraDeepReading.setTier)
            window.DeckauraDeepReading.setTier(
              state.tier,
              silent ? "random_tarot_restore" : "random_tarot_package",
            );
        } catch (_) {}
      }
      syncLegacyTier();
      saveState();
      if (!silent && hasCurrentReading()) enableReading(state.tier, false);
      syncControls();
      if (!silent)
        track("random_tarot_package_selected_v5", { tier: state.tier });
    }
    function renderResult(restoreMode) {
      var rawName = state.card[0],
        name = cardName(),
        orientation = orientationLabel();
      renderCard();
      ask.hidden = true;
      result.hidden = false;
      plans.hidden = false;
      if (dock) dock.hidden = false;
      if (after) after.hidden = false;
      query(root, "[data-rt52-result-question]").textContent =
        "“" + state.question + "”";
      /* Only echo a focus the visitor picked; the default one stays in the order context. */
      var focusNode = query(root, "[data-rt52-result-focus]");
      focusNode.textContent = state.focus ? focusLabel() : "";
      focusNode.hidden = !state.focus;
      query(root, "[data-rt52-result-card]").textContent =
        name + " · " + orientation;
      query(root, "[data-rt52-result-title]").textContent = name;
      query(root, "[data-rt52-message]").textContent =
        titleCase(meaningText()).replace(/[.!?]+$/, "") +
        ". " +
        (state.reversed ? pack.reversedLine : pack.uprightLine);
      var isCourt = /^(Page|Knight|Queen|King) /.test(rawName);
      query(root, "[data-rt52-open]").textContent = isCourt
        ? pack.courtQuestion(name)
        : pack.openQuestion(name);
      query(root, "[data-rt52-clarify]").textContent = pack.resultCta(name);
      if (bridge) bridge.open = Boolean(state.clarifier || clean(context.value));
      renderClarifiers();
      renderClarifierHook();
      updateFocusBullets();
      updatePlan(state.tier, true);
      saveState();
      waitForReading(0);
      if (restoreMode !== true)
        result.scrollIntoView({ behavior: "smooth", block: "start" });
      track(
        restoreMode
          ? "random_tarot_result_restored_v5"
          : "random_tarot_result_viewed_v5",
        {
          focus: state.focus,
          card: rawName,
          orientation: rawOrientation().toLowerCase(),
          recommended: state.tier,
        },
      );
    }
    function startOver() {
      if (state.checkoutBusy) return;
      invalidateContext();
      clearState();
      window.clearTimeout(drawTimer);
      window.clearTimeout(expiryTimer);
      drawPending = false;
      cancelReconfigure();
      window.clearTimeout(checkoutTimer);
      setCheckoutBusy(false);
      showRetry(false);
      ask.hidden = false;
      result.hidden = true;
      plans.hidden = true;
      if (dock) dock.hidden = true;
      if (after) after.hidden = true;
      if (bridge) bridge.open = false;
      restoreNote.hidden = true;
      question.value = "";
      context.value = "";
      state.focus = "";
      state.question = "";
      state.card = null;
      state.cardIndex = -1;
      state.reversed = false;
      state.clarifier = "";
      state.context = "";
      state.tier = "deeper";
      state.readingReady = false;
      state.checkoutPending = false;
      state.checkoutFailed = false;
      state.lastEnabledSignature = "";
      state.expiresAt = 0;
      drawButton.textContent = translate("Draw My Card");
      error.textContent = "";
      query(root, "[data-rt52-count]").textContent = "0 / 220";
      query(root, "[data-rt52-context-count]").textContent = "0";
      renderFocuses();
      renderSuggestions();
      resetCardFace();
      syncControls();
      try {
        if (window.DeckauraDeepReading && window.DeckauraDeepReading.hide)
          window.DeckauraDeepReading.hide();
      } catch (_) {}
      ask.scrollIntoView({ behavior: "smooth", block: "start" });
      track("random_tarot_started_over_v5", {});
    }
    function readingId() {
      return (
        "random-v5-" +
        hash(
          [state.focus, state.question, state.card[0], rawOrientation()].join(
            "|",
          ),
        )
      );
    }
    function configurationSignature() {
      return hash(
        [
          state.focus,
          state.question,
          state.cardIndex,
          rawOrientation(),
          state.clarifier,
          clean(context.value),
        ].join("|"),
      );
    }
    function setPrices(snapshot) {
      lastPricingSnapshot = snapshot;
      var tiers =
          snapshot && Array.isArray(snapshot.tiers) ? snapshot.tiers : [],
        api = window.DeckauraDeepReading;
      var ready = Boolean(api && api.isPriceReady && api.isPriceReady());
      Object.keys(FALLBACK_PRICES).forEach(function (tier) {
        var quote = tiers.filter(function (item) {
          return item.tier === tier;
        })[0];
        var formatted =
          quote && quote.formatted_price
            ? quote.formatted_price
            : FALLBACK_PRICES[tier];
        queryAll(root, '[data-rt52-price="' + tier + '"]').forEach(
          function (node) {
            node.textContent = formatted;
          },
        );
        if (state.tier === tier)
          query(root, "[data-rt52-button-price]").textContent = formatted;
      });
      if (priceStatus && !state.checkoutBusy && !state.checkoutFailed)
        priceStatus.textContent = ready
          ? pack.priceReady
          : snapshot && snapshot.status === "error"
            ? pack.priceFallback
            : pack.priceLoading;
      if (ready && state.checkoutPending) {
        var generation = contextGeneration;
        window.setTimeout(function () { if (generation === contextGeneration) runCheckout(); }, 0);
      }
      syncControls();
    }
    function enableReading(tier, force) {
      var api = window.DeckauraDeepReading;
      if (!api || typeof api.enable !== "function" || !hasCurrentReading()) return false;
      state.tier = /^(essential|deeper|indepth)$/.test(tier)
        ? tier
        : state.tier;
      var signature = configurationSignature();
      if (
        !force &&
        state.readingReady &&
        configuredGeneration === contextGeneration &&
        signature === state.lastEnabledSignature
      ) {
        try {
          if (api.setTier) api.setTier(state.tier, "random_tarot_existing");
        } catch (_) {}
        return true;
      }
      var focus = focusObject(),
        keys = keywordLabels(),
        userContext = clean(context.value).slice(0, 360),
        generation = contextGeneration;
      try {
        configuredGeneration = generation;
        api.enable({
          type: "Random Tarot Card",
          tool: "Random One-Card Tarot Generator",
          canonicalPage: "/pages/random-tarot-card",
          context:
            "Random one-card tarot pull. Focus: " +
            focus.label +
            '. Exact question: "' +
            state.question +
            '". Card: ' +
            state.card[0] +
            " (" +
            rawOrientation() +
            "). Core signal: " +
            state.card[2] +
            ". Keywords: " +
            keys.join(", ") +
            ". Still unclear: " +
            (state.clarifier || "not supplied") +
            ". Optional customer context: " +
            (userContext || "not supplied") +
            ".",
          signals: [
            { label: "Reading focus", value: focus.label },
            { label: "Exact question", value: state.question },
            { label: "Card", value: state.card[0] },
            { label: "Orientation", value: rawOrientation() },
            {
              label: "Still unclear",
              value: state.clarifier || "Not supplied",
            },
            { label: "Customer context", value: userContext || "Not supplied" },
          ],
          signalLimit: 6,
          cards: [
            {
              name: state.card[0],
              orientation: rawOrientation(),
              position: "Original one-card pull",
            },
          ],
          cardLimit: 1,
          spread: "Question-led one-card random pull",
          scope:
            "Continue only from the supplied focus, exact question, original card, orientation, optional unresolved question, optional customer context and selected package depth. Keep the original card as the anchor. Do not invent private thoughts, guaranteed outcomes or exact dates.",
          confidence:
            "Random symbolic one-card draw; reflective guidance rather than factual prediction.",
          readingId: readingId(),
          focus: focus.label,
          fixedFocus: focus.label,
          question: state.question,
          curiosityQuestion: state.clarifier || state.question,
          requireContext: false,
          resultReady: true,
          checkoutRecoveryHost: cartReview,
          onCartReviewReady: function (host) { cartReviewReady(generation, host); },
          defaultTier: state.tier,
          presentationVariant: "random-tarot-enterprise-v5",
          analyticsTopic: "random-tarot",
          gate: false,
          teaser: false,
          title: "Continue from this exact one-card pull",
          text: "Your focus, exact question, original card, orientation and optional context remain attached. Choose how deeply you want the message applied.",
          button: "Continue to secure checkout",
          packageLabels: {
            essential: translate(PACKAGE_NAMES.essential),
            deeper: translate(PACKAGE_NAMES.deeper),
            indepth: translate(PACKAGE_NAMES.indepth),
          },
          checkoutProperties: function (checkoutPackage) {
            var tierName =
                (checkoutPackage && checkoutPackage.tier) || state.tier,
              spec = PACKAGE_SCOPE[tierName] || PACKAGE_SCOPE.deeper,
              currentContext = clean(context.value).slice(0, 360);
            return {
              "_Random focus": focus.label,
              "_Random question": state.question,
              "_Random card": state.card[0],
              "_Random orientation": rawOrientation(),
              "_Still unclear": state.clarifier || "Not supplied",
              "_Customer context": currentContext || "Not supplied",
              "_Random package": PACKAGE_NAMES[tierName],
              "_Added clarifiers": String(spec.added),
              "_Reading horizon": spec.horizon,
              "_Reading promise": spec.promise,
            };
          },
          onTierChange: function (nextTier) {
            if (generation !== contextGeneration || !hasCurrentReading()) return;
            if (/^(essential|deeper|indepth)$/.test(String(nextTier || ""))) {
              state.tier = nextTier;
              syncPlanSelection();
              syncLegacyTier();
              setPrices(lastPricingSnapshot);
              saveState();
            }
          },
          onPricingStateChange: function (snapshot) { if (generation === contextGeneration && hasCurrentReading()) setPrices(snapshot); },
          onPriceReady: function () {
            if (generation !== contextGeneration || !hasCurrentReading()) return;
            if (api.getPricingSnapshot) setPrices(api.getPricingSnapshot());
            if (state.checkoutPending) window.setTimeout(function () { if (generation === contextGeneration) runCheckout(); }, 0);
          },
        });
        if (api.setTier) api.setTier(state.tier, "random_tarot_result");
        if (api.hide) api.hide();
        if (api.getPricingSnapshot) setPrices(api.getPricingSnapshot());
        state.readingReady = true;
        state.lastEnabledSignature = signature;
        armExpiry();
        syncControls();
        return true;
      } catch (exception) {
        state.readingReady = false;
        configuredGeneration = -1;
        syncControls();
        if (priceStatus) priceStatus.textContent = pack.loadFailed;
        showRetry(true);
        track("random_tarot_enable_failed_v5", {
          reason: (exception && exception.message) || "unknown",
        });
        return false;
      }
    }
    function waitForReading(attempt, generation) {
      if (generation == null) generation = contextGeneration;
      if (generation !== contextGeneration || !hasCurrentReading()) return;
      if (enableReading(state.tier, false)) return;
      if (attempt < 80)
        readingTimer = window.setTimeout(function () {
          waitForReading(attempt + 1, generation);
        }, 100);
      else {
        if (priceStatus) priceStatus.textContent = pack.loadFailed;
        showRetry(true);
      }
    }
    function scheduleReconfigure() {
      window.clearTimeout(configTimer);
      var generation = contextGeneration;
      configTimer = window.setTimeout(function () {
        configTimer = 0;
        if (generation === contextGeneration && hasCurrentReading()) waitForReading(0, generation);
        syncControls();
      }, 650);
      syncControls();
    }
    function runCheckout() {
      if (!state.checkoutPending || expireReading() || !hasCurrentReading() || configuredGeneration !== contextGeneration) return;
      var api = window.DeckauraDeepReading;
      if (!api || typeof api.checkoutNow !== "function") {
        state.checkoutPending = false;
        setCheckoutBusy(false);
        if (priceStatus)
          priceStatus.textContent = translate(
            "Secure checkout is still loading. Please try again in a moment.",
          );
        showRetry(true);
        return;
      }
      if (api.isPriceReady && !api.isPriceReady()) return;
      state.checkoutPending = false;
      state.checkoutFailed = false;
      showRetry(false);
      setCheckoutBusy(true);
      window.clearTimeout(checkoutTimer);
      var started = false,
        outcome = null,
        attempt = ++checkoutAttempt,
        generation = contextGeneration;
      try {
        if (typeof api.checkoutNowAsync === "function") {
          outcome = api.checkoutNowAsync();
          started = Boolean(outcome && typeof outcome.then === "function");
        } else started = api.checkoutNow() === true;
      } catch (_) {
        started = false;
      }
      track("random_tarot_checkout_clicked_v5", {
        tier: state.tier,
        focus: state.focus,
        card: state.card[0],
      });
      if (!started) {
        setCheckoutBusy(false);
        state.checkoutFailed = true;
        if (priceStatus) priceStatus.textContent = pack.checkoutFailed;
        showRetry(true);
        track("random_tarot_checkout_failed_v5", {
          tier: state.tier,
          reason: "checkout_not_started",
        });
        return;
      }
      checkoutTimer = window.setTimeout(function () {
        if (attempt !== checkoutAttempt || generation !== contextGeneration || !state.checkoutBusy) return;
        if (priceStatus) priceStatus.textContent = pack.checkoutLong;
      }, 20000);
      if (outcome) outcome.then(function (outcomeResult) {
        if (attempt !== checkoutAttempt || generation !== contextGeneration || !hasCurrentReading()) return;
        if (outcomeResult && outcomeResult.ok) return;
        window.clearTimeout(checkoutTimer);
        state.checkoutPending = false;
        if (outcomeResult && (outcomeResult.reason === "checkout_return_recovered" || recoverableCartReason(outcomeResult.reason))) {
          state.checkoutFailed = false;
          setCheckoutBusy(false);
          setPrices(lastPricingSnapshot);
          return;
        }
        if (outcomeResult && outcomeResult.reason === "checkout_timeout" && state.checkoutBusy) {
          if (priceStatus) priceStatus.textContent = pack.checkoutLong;
          return;
        }
        state.checkoutFailed = true;
        setCheckoutBusy(false);
        if (priceStatus) priceStatus.textContent = pack.checkoutFailed;
        showRetry(true);
      }).catch(function () {
        if (attempt !== checkoutAttempt || generation !== contextGeneration || !hasCurrentReading()) return;
        window.clearTimeout(checkoutTimer);
        state.checkoutPending = false;
        state.checkoutFailed = true;
        setCheckoutBusy(false);
        if (priceStatus) priceStatus.textContent = pack.checkoutFailed;
        showRetry(true);
      });
    }
    function checkout() {
      if (state.checkoutBusy || expireReading() || !hasCurrentReading() || reviewPending || Boolean(cartReview && !cartReview.hidden)) return;
      state.context = clean(context.value).slice(0, 360);
      saveState();
      cancelReconfigure();
      state.checkoutPending = true;
      state.checkoutFailed = false;
      showRetry(false);
      var api = window.DeckauraDeepReading;
      if (
        !enableReading(state.tier, false) ||
        !api ||
        typeof api.checkoutNow !== "function"
      ) {
        state.checkoutPending = false;
        if (priceStatus)
          priceStatus.textContent = translate(
            "Secure checkout is still loading. Please try again in a moment.",
          );
        showRetry(true);
        waitForReading(0);
        return;
      }
      try {
        if (api.setTier) api.setTier(state.tier, "user");
      } catch (_) {}
      if (api.isPriceReady && !api.isPriceReady()) {
        var generation = contextGeneration;
        setCheckoutBusy(true);
        if (priceStatus) priceStatus.textContent = pack.priceQueued;
        try {
          if (api.retryPricing) api.retryPricing();
        } catch (_) {}
        window.clearTimeout(checkoutTimer);
        checkoutTimer = window.setTimeout(function () {
          if (generation !== contextGeneration || !state.checkoutPending) return;
          state.checkoutPending = false;
          setCheckoutBusy(false);
          if (priceStatus) priceStatus.textContent = pack.checkoutFailed;
          showRetry(true);
        }, 15000);
        return;
      }
      runCheckout();
    }
    function shareResult() {
      if (!state.card) return;
      var text =
        cardName() +
        " — " +
        orientationLabel() +
        ". " +
        pack.shareQuestion +
        ": “" +
        state.question +
        "”";
      var url = window.location.href.split("#")[0];
      function copied() {
        showToast(translate("Result summary copied."));
        track("random_tarot_result_shared_v5", { method: "clipboard" });
      }
      function failed() {
        showToast(
          translate(
            "We could not copy the result. Please copy the page link manually.",
          ),
        );
      }
      var payload = text + "\n" + url;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        Promise.resolve(navigator.clipboard.writeText(payload))
          .then(copied)
          .catch(failed);
        return;
      }
      try {
        var area = document.createElement("textarea");
        area.value = payload;
        area.setAttribute("readonly", "");
        area.style.position = "fixed";
        area.style.opacity = "0";
        document.body.appendChild(area);
        area.select();
        var ok = document.execCommand("copy");
        area.remove();
        if (ok) copied();
        else failed();
      } catch (_) {
        failed();
      }
    }
    function restoreState() {
      var saved = readState();
      if (!saved) return false;
      state.expiresAt = saved.expiresAt;
      if (
        FOCI.some(function (item) {
          return item.id === saved.focus;
        })
      )
        state.focus = saved.focus;
      state.question = clean(saved.question).slice(0, 220);
      question.value = state.question;
      query(root, "[data-rt52-count]").textContent =
        state.question.length + " / 220";
      state.context = clean(saved.context).slice(0, 360);
      context.value = state.context;
      query(root, "[data-rt52-context-count]").textContent =
        state.context.length;
      if (/^(essential|deeper|indepth)$/.test(saved.tier))
        state.tier = saved.tier;
      if (CLARIFIERS.indexOf(saved.clarifier) > -1)
        state.clarifier = saved.clarifier;
      renderFocuses();
      renderSuggestions();
      var index = saved.cardIndex;
      if (Number.isInteger(index) && index >= 0 && index < deck.length && Array.from(state.question).length >= MIN_QUESTION) {
        state.cardIndex = index;
        state.card = deck[index];
        state.reversed = saved.reversed === true;
        renderResult(true);
        armExpiry();
        restoreNote.textContent = pack.restored;
        restoreNote.hidden = false;
        showToast(pack.restored);
      } else {
        state.cardIndex = -1;
        state.card = null;
        updatePlan(state.tier, true);
      }
      return true;
    }

    question.addEventListener("input", function () {
      if (state.checkoutBusy || drawPending) return;
      invalidateContext();
      question.value = question.value.slice(0, 220);
      state.question = question.value;
      query(root, "[data-rt52-count]").textContent =
        state.question.length + " / 220";
      error.textContent = "";
      question.removeAttribute("aria-invalid");
      saveState();
    });
    context.addEventListener("input", function () {
      if (state.checkoutBusy || !hasCurrentReading()) return;
      invalidateContext();
      context.value = context.value.slice(0, 360);
      state.context = context.value;
      query(root, "[data-rt52-context-count]").textContent =
        state.context.length;
      saveState();
      scheduleReconfigure();
    });
    drawButton.addEventListener("click", draw);
    query(root, "[data-rt52-start-over]").addEventListener("click", startOver);
    query(root, "[data-rt52-clarify]").addEventListener("click", function () {
      plans.scrollIntoView({ behavior: "smooth", block: "start" });
      track("random_tarot_clarify_clicked_v5", { focus: state.focus });
    });
    query(root, "[data-rt52-copy]").addEventListener("click", shareResult);
    queryAll(root, "[data-rt52-plan]").forEach(function (node) {
      node.addEventListener("click", function () {
        updatePlan(node.getAttribute("data-rt52-plan"), false);
      });
      node.addEventListener("keydown", function (event) {
        if (state.checkoutBusy || !/^(ArrowLeft|ArrowRight|ArrowUp|ArrowDown|Home|End)$/.test(event.key)) return;
        event.preventDefault();
        var nodes = queryAll(root, "[data-rt52-plan]"), index = nodes.indexOf(node);
        if (event.key === "Home") index = 0;
        else if (event.key === "End") index = nodes.length - 1;
        else index = (index + (/^(ArrowRight|ArrowDown)$/.test(event.key) ? 1 : -1) + nodes.length) % nodes.length;
        updatePlan(nodes[index].getAttribute("data-rt52-plan"), false);
        nodes[index].focus();
      });
    });
    checkoutButton.addEventListener("click", checkout);
    retryButton.addEventListener("click", function () {
      if (state.checkoutBusy || expireReading() || !hasCurrentReading()) return;
      if (priceStatus) priceStatus.textContent = pack.retrying;
      showRetry(false);
      setCheckoutBusy(false);
      state.checkoutPending = false;
      checkout();
    });
    queryAll(root, ".rt52__faqitem button").forEach(function (button) {
      button.addEventListener("click", function () {
        var panel = button.nextElementSibling,
          open = panel.hidden;
        panel.hidden = !open;
        button.setAttribute("aria-expanded", String(open));
        query(button, "span").textContent = open ? "−" : "+";
      });
    });
    document.addEventListener("deckaura:funnel-event", function (event) {
      var detail = (event && event.detail) || {}, data = detail.data || {};
      if (detail.readingType !== "Random Tarot Card" || configuredGeneration !== contextGeneration || !hasCurrentReading() || (data.reading_id && data.reading_id !== readingId()))
        return;
      if (detail.name === "checkout_prepare_start") {
        clearCartReview();
        setCheckoutBusy(true);
        dismissReturnHint();
        state.checkoutFailed = false;
        showRetry(false);
        if (priceStatus) priceStatus.textContent = pack.checkoutPreparing;
      } else if (detail.name === "checkout_cart_ready") {
        if (priceStatus) priceStatus.textContent = pack.cartReady;
      } else if (detail.name === "checkout_prepare_error") {
        window.clearTimeout(checkoutTimer);
        state.checkoutPending = false;
        reviewReason = recoverableCartReason(data.reason) ? data.reason : "";
        reviewPending = Boolean(reviewReason);
        beforeReviewStatuses = reviewReason === "reading_cart_conflict" ? sharedStatuses() : [];
        returnStatuses = null;
        state.checkoutFailed = !reviewReason;
        setCheckoutBusy(false);
        if (reviewReason) setPrices(lastPricingSnapshot);
        else {
          if (priceStatus) priceStatus.textContent = pack.checkoutFailed;
          showRetry(true);
        }
        track("random_tarot_checkout_failed_v5", {
          tier: state.tier,
          reason: "checkout_prepare_error",
        });
      } else if (detail.name === "checkout_return_recovered") {
        window.clearTimeout(checkoutTimer);
        checkoutAttempt += 1;
        state.checkoutPending = false;
        state.checkoutFailed = false;
        setCheckoutBusy(false);
        setPrices(lastPricingSnapshot);
      }
    });
    window.addEventListener("pageshow", function (event) {
      var statuses = event.persisted === true && configuredGeneration === contextGeneration && hasCurrentReading() && !state.checkoutBusy ? returnStatuses : null;
      if (expireReading()) return;
      window.clearTimeout(checkoutTimer);
      checkoutAttempt += 1;
      state.checkoutPending = false;
      state.checkoutFailed = false;
      clearCartReview();
      if (statuses) statuses.forEach(function (entry) { if (entry.node.isConnected && entry.node.textContent === entry.text) entry.node.textContent = ""; });
      setCheckoutBusy(false);
      if (
        state.readingReady &&
        window.DeckauraDeepReading &&
        window.DeckauraDeepReading.getPricingSnapshot
      )
        setPrices(window.DeckauraDeepReading.getPricingSnapshot());
    });
    document.addEventListener("visibilitychange", function () { if (!document.hidden) expireReading(); });
    /* The status line sits in the checkout dock: show it for loading, retry and checkout progress, not for the routine "prices confirmed". */
    function syncQuietStatus() {
      if (priceStatus) priceStatus.classList.toggle("is-quiet", !priceStatus.textContent || priceStatus.textContent === pack.priceReady);
    }
    if (priceStatus && typeof window.MutationObserver === "function")
      new window.MutationObserver(syncQuietStatus).observe(priceStatus, { childList: true, characterData: true, subtree: true });

    renderFocuses();
    renderSuggestions();
    resetCardFace();
    if (!restoreState()) updatePlan("deeper", true);
  }
  function init() {
    queryAll(document, "[data-rt52-root]").forEach(boot);
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
